import HomePageCarousel from "../../components/HomePageCarousel/HomePageCarousel";

import classes from "./styles.scss";

const Home = () => {
    return <HomePageCarousel className={classes.homePagaCarousel} />    
}

export default Home;
